<template>
  <div class="side_btn" :style="style">
    <BaseButton v-if="hasButton" color="primary" type="submit" size="big" @click.native="emitClick(true)">
      {{ title }}
      <BaseIcon v-if="isAdd" name="plus-circle" class="icon white" />
    </BaseButton>
  </div>
</template>

<script>
import BaseButton from "@/components/base/Button";
import BaseIcon from "@/components/base/Icon";

export default {
  components: {
    BaseButton,
    BaseIcon
  },
  computed: {
    style() {
      return "height: " + this.height + "%";
    },
    userDetails() {
      return this.$store.state.userDetails
    }
  },
  props: {
    height: String,
    hasButton: Boolean,
    title: String,
    isAdd: Boolean
  },
  methods: {
    emitClick(isClicked) {
      this.$emit('clickedButton', isClicked);
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base.scss";
.side_btn {
  height: 90px;
}
</style>
